module.exports = __webpack_public_path__ + "img/HIW-PRICE.dca7a4b5.png";